module.exports = __webpack_public_path__ + "images/discover_offer-expired-mobile.jpg";